import styled from 'styled-components';
import Image from 'next/image';
import Caption from './Caption';

const ImageContainer = styled.div`
  margin-bottom: 24px;

  img {
    max-width: 100%;
    height: auto;
    background-color: #ececec;
  }

  &.emphasized {
    width: 130%;
    margin: 0 -15% 2rem -15%;
  }

  @media screen and (min-width: 768px) {
    &.emphasized {
      width: 130%;
      margin: 0 -15% 2rem -15%;
    }
  }
  @media screen and (min-width: 768px) {
    &.emphasized {
      width: 130%;
      margin: 0 -15% 2rem -15%;
    }
  }
`;

const DefaultImage = ({
  slice,
}: {
  slice: { primary: { image?: any; caption?: any }; slice_label: any };
}) => {
  const imageUrl = slice.primary.image.url;
  const imageAlt = slice.primary.image.alt;
  const { caption } = slice.primary;

  return (
    <div className="post-part single container">
      <ImageContainer className={`block-img ${slice.slice_label}`}>
        <Image
          src={imageUrl}
          alt={imageAlt}
          width={slice.primary.image.dimensions.width}
          height={slice.primary.image.dimensions.height}
        />
        <Caption caption={caption} />
      </ImageContainer>
    </div>
  );
};

export default DefaultImage;
